import Image from '@components/Image'
import { Link } from 'gatsby'
import React from 'react'
import { Container } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const MOCKDATA: RealEstateDataPageComponentData = {
  title: 'SOBRE NOSOTROS',
}

const VideoYoutube1 = (props: RealEstateDataPageComponentData) => {
  const { isDemo } = props
  const { title, spanText } = isDemo ? MOCKDATA : props

  return (
    <section className={'video-section-yt p-y-config text-center a'}>
      <Container fluid>
        <h2 className='mb-lg-4 mb-3'>{title}</h2>
        <div className="frame-container">
          <iframe
            width="100%"
            src={
              'https://www.youtube.com/embed/' +
              spanText +
              '?si=70FLk7NqFtQlS8no&modestbranding=1&autohide=1&showinfo=0&controls=0'
            }
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            frameBorder={0}
          ></iframe>
        </div>
      </Container>
    </section>
  )
}

export default VideoYoutube1
